import {
    GESTION_OPERATIVA_CHANGE_STATE_BEGIN,
    GESTION_OPERATIVA_CHANGE_STATE_SUCCESS,
    GESTION_OPERATIVA_CHANGE_STATE_ERROR
} from '../constants'
import { ACTION_STATE } from '../../../common/Utilities'

export function reducer(state, action) {
    switch (action.type) {
        case GESTION_OPERATIVA_CHANGE_STATE_BEGIN:
            return {
                ...state,
                changeState: ACTION_STATE.PENDING
            }
        case GESTION_OPERATIVA_CHANGE_STATE_SUCCESS:
            return {
                ...state,
                changeState: ACTION_STATE.SUCCESS,
                sale:{
                    ...state.sale,
                    sale_state: action.data.sale_state,
                    observation: action.data.observation
                }
            }
        case GESTION_OPERATIVA_CHANGE_STATE_ERROR:
            return {
                ...state,
                changeState: ACTION_STATE.ERROR
            }
        default:
            return state
    }
}